import { Component, effect, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AnalyticsService } from '@gruposaltaedu/liv-analytics';
import { Store } from '@ngxs/store';

import { LoaderOverlayService } from '@app/core/ui/components/loader-overlay/loader-overlay.service';
import { LoadingStateEnum } from '@app/shared/enums/loading-state.enum';

import { StoreHeaderComponent } from './components/store-header/store-header.component';
import { StoreNavbarComponent } from './components/store-navbar/store-navbar.component';
import { LoadStudentByTokenAction } from '../../../features/student/store/student/student.action';
import { StudentState } from '../../../features/student/store/student/student.state';

@Component({
  standalone: true,
  selector: 'mw-store-layout',
  imports: [RouterOutlet, StoreHeaderComponent, StoreNavbarComponent],
  templateUrl: './store-layout.component.html',
  styleUrl: './store-layout.component.scss',
  host: {
    '(document:click)': 'onDocumentClick($event)'
  }
})
export class StoreLayoutComponent implements OnInit {
  private readonly requestStatus = this.store.selectSignal(
    StudentState.requestStatus
  );

  protected readonly isMenuCollapsed = signal(true);

  constructor(
    private readonly store: Store,
    private readonly loader: LoaderOverlayService,
    private readonly livAnalytics: AnalyticsService
  ) {
    effect(() => {
      if (this.requestStatus()?.status === LoadingStateEnum.loading) {
        this.loader.show();
      } else {
        this.loader.hide();
      }
    });
  }

  ngOnInit(): void {
    this.store.dispatch(new LoadStudentByTokenAction());
  }

  onDocumentClick(event: Event): void {
    this.livAnalytics.track(event);
  }

  toggleMenuCollapse() {
    this.isMenuCollapsed.update((prev) => !prev);
  }
}
